import { ProductSlide } from '../../../models/slides/ProductSlide';
import { fadeAnimation, fadeAnimationName } from '../../../utils/fadeAnimation';
import { useCalculatedDiscount } from 'shared-widget-components/src/hooks/useCalculatedDiscount';
import { useTranslation } from 'react-i18next';
import { WineDiscount } from './WineDiscount';
import { WinePriceContent } from './WinePriceContent';
import { WineTextContent } from './WineTextContent';
import { useWineContent } from './hooks/useWineContent';

interface WineSlideProps {
  // the list of the carousel slides
  slides: ProductSlide[];
  // the index of the currently active slide
  currentIndex: number;
  // the color of the text
  textColor: string;
  // the color of the button
  buttonColor: string;
  // the color of the button text
  buttonTextColor: string;
}

/**
 * WineContent component
 * this component is responsible for rendering the wine content
 * @param currentIndex - the index of the currently active slide
 * @param buttonColor - the color of the button
 * @param buttonTextColor - the color of the button text
 * @param textColor - the color of the text
 * @param slides - the list of the carousel slides
 * @returns WineContent component
 */

const WineContent = ({ currentIndex, buttonColor, buttonTextColor, textColor, slides }: WineSlideProps) => {
  const { t } = useTranslation();

  const { wineData, onWineClick } = useWineContent({ slides, currentIndex });

  const basePrice = wineData.basePrice!;
  const currentPrice = wineData.currentPrice!;

  const { calculatedDiscount } = useCalculatedDiscount({ basePrice, currentPrice });

  // @ts-ignore
  const isAdmin = window.isAdminPage;

  if (!wineData.productVariantId) return <></>;

  return (
    <div className='min-[350px]:mt-2 md:mt-4 h-full flex flex-col justify-between' style={{ animation: fadeAnimation, animationName: fadeAnimationName }}>
      <div className='h-2/4'>
        <WineDiscount wineData={wineData} textColor={textColor} calculatedDiscount={calculatedDiscount} />
        <WineTextContent wineData={wineData} textColor={textColor} />
      </div>
      <div className='h-1/4 min-[350px]:mb-3 sm:mb-1 md:mb-5 min-[1200px]:mb-6'>
        <WinePriceContent wineData={wineData} textColor={textColor} calculatedDiscount={calculatedDiscount} />
      </div>
      <div className='h-1/4'>
        <button
          type='button'
          onClick={onWineClick}
          disabled={isAdmin}
          className={`rounded mt-auto min-[350px]:font-semibold sm:font-medium min-[350px]:w-full sm:w-fit min-[350px]:text-[14px] sm:text-[16px]  px-3  py-2 cursor-pointer font-body`}
          style={{ backgroundColor: buttonColor, color: buttonTextColor, cursor: isAdmin ? 'not-allowed' : 'pointer' }}
        >
          {t('carousel.viewOffer')}
        </button>
      </div>
    </div>
  );
};

export default WineContent;
